import React from 'react';
import { Image } from '../Image/Image.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { Text } from '../Text/Text.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Avatar as Avatar$1 } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Avatar = forwardRef((_a, ref) => {
  var _b = _a, { src, fallback = "", alt, size = "md", isDimmed = false, isRound = true, srcSet } = _b, props = __objRest(_b, ["src", "fallback", "alt", "size", "isDimmed", "isRound", "srcSet"]);
  return /* @__PURE__ */ React.createElement(Avatar$1, __spreadValues({
    size,
    ref,
    isRound,
    opacity: isDimmed ? 0.5 : 1
  }, props), /* @__PURE__ */ React.createElement(Image, {
    src,
    srcSet,
    alt,
    fallback: !!fallback && size !== "xxs" ? /* @__PURE__ */ React.createElement(Text, {
      fontSize: size
    }, fallback) : /* @__PURE__ */ React.createElement(React.Fragment, null)
  }));
});
Avatar.displayName = "Avatar";

export { Avatar };
//# sourceMappingURL=Avatar.es.js.map
